import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import AssetQuantityField from "../../../../views/inventory/requests/AssetQuantityField";

export default function LocationSnapshotEditQuantityModal({
  asset,
  currentQuantity,
  locationName,
  saving,
  onSave,
  onClose,
}) {
  const [quantity, setQuantity] = useState(currentQuantity);

  return (
    <Dialog open onClose={() => !saving && onClose()} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography fontSize={22} fontWeight={500} color="text.secondary" align="center">
          Edit Location Quantity
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          disabled={saving}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" py={4}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {asset.itemId || asset.assetId} &mdash; {locationName}
          </Typography>
          <AssetQuantityField
            quantity={quantity}
            onChange={setQuantity}
            size="large"
            disabled={saving}
            quantityProps={{
              label: "Quantity",
              style: { minWidth: 160 },
              InputLabelProps: { shrink: true },
              autoFocus: true,
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, justifyContent: "flex-end" }}>
        <Button variant="outlined" onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={saving || quantity < 0}
          onClick={() => onSave(quantity)}
          startIcon={saving ? <CircularProgress size={18} /> : undefined}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
